import {
  AfterViewChecked,
  Component, ElementRef,
  Input,
  OnInit, QueryList,
  ViewChildren
} from '@angular/core';
import Chart, {ChartPoint, ChartType} from 'chart.js';
import {ChartDataSets, ChartOptions} from 'chart.js';

import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {SingleChartComponent} from "./singleChart/single-chart.component";
import {SliderService} from "../app-exc-slider/slider.service";

@Component({
  selector: 'app-chart-slider',
  templateUrl: './chart-slider.component.html',
  styleUrls: ['./chart-slider.component.scss'],
  providers: [SliderService]
})
export class ChartSliderComponent extends ExcTranslation implements OnInit, AfterViewChecked {
  _charts = null;
  // @Input() charts = null;
  get charts() {
    return this._charts;
  }
  @Input() set charts(value) {
    this._charts = value;
    if (this._charts !== undefined && this._charts !== null) {
      for (const x of this._charts) {
        this.hasData(x);
      }
    }
  }
  @ViewChildren('chartCanvas') chartElements: QueryList<ElementRef>;
  chartArray = [];
  private colors = [
    {f: 'rgba(32, 83, 148, 1)', b: 'rgba(32, 83, 148, 0.4)'},
    {f: 'rgba(250, 169, 51, 1)', b: 'rgba(250, 169, 51, 0.4)'},
    {f: 'rgba(3, 181, 56, 1)', b: 'rgba(3, 181, 56, 0.4)'},
    {f: 'rgba(88, 200, 224, 1)', b: 'rgba(88, 200, 224, 0.4)'},
    {f: 'rgba(181, 3, 154, 1)', b: 'rgba(181, 3, 154, 0.4)'}
  ];
  private colorCodes = {
    success:    {f: 'rgba(3, 181, 56, 1)', b: 'rgba(3, 181, 56, 0.4)'},
    secondary: {f: 'rgba(32, 83, 148, 1)', b: 'rgba(32, 83, 148, 0.4)'},
    warning: {f: 'rgba(250, 169, 51, 1)', b: 'rgba(250, 169, 51, 0.4)'},
    tertiary: {f: 'rgba(88, 200, 224, 1)', b: 'rgba(88, 200, 224, 0.4)'},
    odd: {f: 'rgba(181, 3, 154, 1)', b: 'rgba(181, 3, 154, 0.4)'},
    danger: {f: 'rgba(201, 48, 44, 1)', b: 'rgba(201, 48, 44, 0.4)'}
  }
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewChecked(): void {
    const _self = this;
    if (this.chartArray.length === 0 && this.charts) {
      this.charts.forEach((elem, index) => {
        if (this.charts[index].hasData === true) {
          this.generateChart(index);
        }
      });
    }
  }

  getTitle(index: number) {
    if (!this.charts) {
      return this.getRessource('Loading');
    } else if (this.charts && this.charts.length > 0) {
      return this.getRessource(this.charts[index].Title);
    }
    return this.getGlobal('NoData');
  }
  hasData(chart) {
    if (chart.hasData === undefined) {
      chart.hasData = false;
      for (const d of chart.datasets) {
        if (d.data !== undefined && d.data !== null && d.data.length > 0) {
          for (const d2 of d.data) {
            if (d2 !== null && d2 !== 0) {
              chart.hasData = true;
              break;
            }
          }
        }
        if (chart.hasData === true) {
          break;
        }
      }
    }
    return chart.hasData;
  }

  generateChart(index: number) {
    const context = this.chartElements
      .find((element, elementIndex) => elementIndex  === index).nativeElement
      .getContext('2d');
    const c = this.charts[index];
    let colorIndex = 0;
    if (c.datasets.length === 1 && (c.datasets[0].type === 'pie' || c.datasets[0].type === 'doughnut')) {
      if (c.datasets[0].labelTranslated !== true) {
        c.datasets[0].label = this.getRessource(c.datasets[0].label);
        c.datasets[0].labelTranslated = true;
      }
      c.datasets[0].borderWidth = 1;
      c.datasets[0].backgroundColor = [];
      c.datasets[0].borderColor = [];
      for (let ci = 0; ci < c.datasets[0].data.length; ci++) {
        if (c.colors !== undefined) {
          if (c.colors[ci] !== '') {
            c.datasets[0].backgroundColor.push(this.colorCodes[c.colors[ci]].b);
            c.datasets[0].borderColor.push(this.colorCodes[c.colors[ci]].f);
          } else {
            c.datasets[0].backgroundColor.push(this.colors[ci % this.colors.length].b);
            c.datasets[0].borderColor.push(this.colors[ci % this.colors.length].f);
          }
        } else {
          c.datasets[0].backgroundColor.push(this.colors[ci % this.colors.length].b);
          c.datasets[0].borderColor.push(this.colors[ci % this.colors.length].f);
        }
      }
      if (c.IsPercent && c.IsPercent === true) {
        let total = 0;
        for (const sd of c.datasets[0].data) {
          total = total + sd;
        }
        for (let sdi = 0; sdi < c.datasets[0].data.length; sdi++) {
          let tmp = c.datasets[0].data[sdi];
          tmp = tmp * 100 / total;
          c.datasets[0].data[sdi] = Math.round(tmp);
        }
      }

      // for (const a of this.colors) {
      //   c.datasets[0].backgroundColor.push(a.b);
      //   c.datasets[0].borderColor.push(a.f);
      // }
      for (let l = 0; l < c.labels.length; l++) {
        const nl = this.getRessource(c.labels[l]);
        if (nl !== null && nl !== '' && (nl.indexOf('ChartSliderComponent') === -1 && nl.indexOf('SingleChartComponent') === -1 )) {
          c.labels[l] = nl;
        }
      }
    } else {
      for (const d of c.datasets) {
        if (d.labelTranslated !== true) {
          d.label = this.getRessource(d.label);
          d.labelTranslated = true;
        }
        d.borderWidth = 1;
        d.backgroundColor = this.colors[colorIndex].b;
        d.borderColor = this.colors[colorIndex].f;
        colorIndex = colorIndex + 1;
        if (colorIndex === this.colors.length - 1) {
          colorIndex = 0;
        }
      }
    }
    const opt = c.Option === null || c.Option === undefined ? {} : JSON.parse(c.Option);
    opt['responsive'] = true;
    opt['maintainAspectRatio'] = false;
    const x = {
      data: {
        datasets: c.datasets,
        labels: c.labels
      },
      type: c.datasets[0].type,
      options: opt
    };
    if (c.IsPercent && c.IsPercent === true) {
      x.options['tooltips'] = {enabled: true, mode: 'single', callbacks: {label: this.appendPercentSign}};
    } else {
      x.options['tooltips'] = {enabled: true, mode: 'single', callbacks: {label: this.appendStandardSign}};
    }
    this.chartArray = [...this.chartArray, new Chart(context, x)];
  }
  appendPercentSign(tooltipItems, data) {
    return data.labels[tooltipItems.index] + ': ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%';
  }
  appendStandardSign(tooltipItems, data) {
    return data.labels[tooltipItems.index] + ': ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index];
  }
  openChartModal(index: number) {
    ExcCoreModule.showModal(SingleChartComponent, null, 'xl', this.charts[index], true).subscribe();
  }
}
